import { SignalsContract } from '@terra/shared-contracts-signals';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const signalsClient = createTerraOrpcClient({
  contract: SignalsContract,
  serviceName: SERVICE_NAME,
});
